import { CardConditionStyled } from '@/components/CardCondition/styled';
import CustomCard from '@/components/customCard';
import RegularText from '@/components/RegularText';
import { Badge, Button, Icon, IconSource } from '@shopify/polaris';
import { PlusIcon } from '@shopify/polaris-icons';
import { Tone } from '@shopify/polaris/build/ts/src/components/Badge';
import { useMediaQuery } from 'react-responsive';
import UpgradeTextWithTouchPoint from '../UpgradeTextWithTouchPoint';

interface Props {
  children: React.ReactNode;
  icon: IconSource;
  title?: string;
  badgeContent?: React.ReactNode;
  badgeTone?: Tone;
  subTitle?: string;
  buttonText: string;
  onAction: () => void;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  isShowButtonOnBottom?: boolean;
  description?: React.ReactNode;
  textLimitedPlan?: React.ReactNode;
}

const CardCondition = ({
  children,
  icon,
  title,
  badgeContent,
  subTitle,
  buttonText,
  onAction,
  badgeTone,
  collapsible,
  defaultExpanded,
  isShowButtonOnBottom,
  textLimitedPlan,
}: Props) => {
  const isMobile = useMediaQuery({ maxWidth: 650 });
  return (
    <CardConditionStyled>
      <CustomCard
        title={
          title && (
            <div className={`${isMobile ? 'flex-column gap-4' : 'flex-row align-center'} d-flex content-between`}>
              <div className="d-flex flex-column w-full">
                <div className="d-flex justify-between">
                  <div className={`d-flex gap-8 mb-8 ${isMobile ? 'flex-column' : 'flex-row align-center'}`}>
                    <div className="d-flex align-center gap-4">
                      <Icon source={icon} tone={textLimitedPlan ? 'subdued' : undefined} />
                      <h2 className={`text-xl font-bold ${textLimitedPlan ? 'text--gray' : ''}`}>{title}</h2>
                    </div>
                    {!!badgeContent && (
                      <div>
                        <Badge tone={badgeTone}>{badgeContent as any}</Badge>
                      </div>
                    )}
                  </div>
                  <UpgradeTextWithTouchPoint text={textLimitedPlan} isVisible={!isMobile && !!textLimitedPlan} />
                </div>
                <RegularText className={textLimitedPlan ? 'text--gray' : ''}>{subTitle}</RegularText>
                <UpgradeTextWithTouchPoint text={textLimitedPlan} isVisible={isMobile && !!textLimitedPlan} />
              </div>
              {!isShowButtonOnBottom && (
                <div className="wrap-button">
                  {!!onAction && (
                    <Button variant="primary" onClick={onAction} icon={PlusIcon}>
                      {buttonText}
                    </Button>
                  )}
                </div>
              )}
            </div>
          )
        }
        textClassName="w-full"
        isTitleFullWidth
        collapsible={collapsible}
        defaultExpanded={!!defaultExpanded}
      >
        {children}
        {isShowButtonOnBottom && (
          <div className="wrap-button mt-16">
            {!!onAction && (
              <Button variant="primary" onClick={onAction} icon={PlusIcon}>
                {buttonText}
              </Button>
            )}
          </div>
        )}
      </CustomCard>
    </CardConditionStyled>
  );
};

export default CardCondition;
